import React from 'react'
import SImage from '../Image';

function ShowAlert({title,message,pic,show,setShow,onClose,swal,svg }) {
    let pict = false;
    let svgIcon = false;

    const handleCloseModal = () => {
        setShow(false);
        if (onClose) {
            onClose(); // Panggil fungsi navigasi setelah modal ditutup
        }
    };

    if(pic !== '' && pic !== null && pic !== undefined){
        pict = true;
    }

    if(svg !== '' && svg !== null && svg !== undefined){
        svgIcon = true;
    }

    const renderPic = () => {
        if (pict) {
            return (
                <div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <SImage className="object-fit-contain m-auto" alt={'no image'} source={pic} width={48} height={48}/>
                </div>
            );
        }else{
            return null;
        }
    };

  return (
    <>
       {show && ( <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="d-flex flex-column align-items-center justify-content-center">
                            <div className={`swal2-icon ${swal} swal2-icon-show mb-3 `}
                            style={{ 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 80,
                                height: 80,
                                margin: '0 auto',
                                position: 'relative'
                            }}>
                                <div className='d-flex'>
                                {renderPic()}
                                { svgIcon && (
                                    <span className={`svg-icon ${svg} svg-icon-2hx`}>
                                        {svg === 'svg-icon-success' && (
                                            <>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3" d="M10.3 14.3L11 13.6L7.70002 10.3C7.30002 9.9 6.7 9.9 6.3 10.3C5.9 10.7 5.9 11.3 6.3 11.7L10.3 15.7C9.9 15.3 9.9 14.7 10.3 14.3Z" fill="currentColor"/>
                                                <path d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM11.7 15.7L17.7 9.70001C18.1 9.30001 18.1 8.69999 17.7 8.29999C17.3 7.89999 16.7 7.89999 16.3 8.29999L11 13.6L7.70001 10.3C7.30001 9.89999 6.69999 9.89999 6.29999 10.3C5.89999 10.7 5.89999 11.3 6.29999 11.7L10.3 15.7C10.5 15.9 10.8 16 11 16C11.2 16 11.5 15.9 11.7 15.7Z" fill="currentColor"/>
                                                </svg>
                                            </>
                                        )}
                                        {svg === 'svg-icon-danger' && (
                                            <>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3" d="M12 10.6L14.8 7.8C15.2 7.4 15.8 7.4 16.2 7.8C16.6 8.2 16.6 8.80002 16.2 9.20002L13.4 12L12 10.6ZM10.6 12L7.8 14.8C7.4 15.2 7.4 15.8 7.8 16.2C8 16.4 8.3 16.5 8.5 16.5C8.7 16.5 8.99999 16.4 9.19999 16.2L12 13.4L10.6 12Z" fill="currentColor"/>
                                                <path d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM13.4 12L16.2 9.20001C16.6 8.80001 16.6 8.19999 16.2 7.79999C15.8 7.39999 15.2 7.39999 14.8 7.79999L12 10.6L9.2 7.79999C8.8 7.39999 8.2 7.39999 7.8 7.79999C7.4 8.19999 7.4 8.80001 7.8 9.20001L10.6 12L7.8 14.8C7.4 15.2 7.4 15.8 7.8 16.2C8 16.4 8.3 16.5 8.5 16.5C8.7 16.5 9 16.4 9.2 16.2L12 13.4L14.8 16.2C15 16.4 15.3 16.5 15.5 16.5C15.7 16.5 16 16.4 16.2 16.2C16.6 15.8 16.6 15.2 16.2 14.8L13.4 12Z" fill="currentColor"/>
                                                </svg>
                                            </>
                                        )}
                                        {svg === 'svg-icon-warning' && (
                                            <>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 36 36"><path fill="#FFCC4D" d="M2.653 35C.811 35-.001 33.662.847 32.027L16.456 1.972c.849-1.635 2.238-1.635 3.087 0l15.609 30.056c.85 1.634.037 2.972-1.805 2.972H2.653z"/>
                                                <path fill="#231F20" d="M15.583 28.953a2.421 2.421 0 0 1 2.419-2.418a2.421 2.421 0 0 1 2.418 2.418a2.422 2.422 0 0 1-2.418 2.419a2.422 2.422 0 0 1-2.419-2.419zm.186-18.293c0-1.302.961-2.108 2.232-2.108c1.241 0 2.233.837 2.233 2.108v11.938c0 1.271-.992 2.108-2.233 2.108c-1.271 0-2.232-.807-2.232-2.108V10.66z"/>
                                                </svg>
                                            </>
                                        )}
                                        {svg === 'svg-icon-info' && (
                                            <>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 48 48">
                                            <circle cx="24" cy="24" r="21" fill="#2196F3"/>
                                                <path fill="#fff" d="M22 22h4v11h-4z"/>
                                            <circle cx="24" cy="16.5" r="2.5" fill="#fff"/>
                                            </svg>
                                            </>
                                        )}
                                    </span>
                                )}
                                </div>
                            </div>
                            <div className="swal2-html-container text-center mb-2" id="swal2-html-container">
                                {message}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer justify-content-center">

                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleCloseModal}
                        >
                            {title}
                        </button>
                        
                    </div>
                </div>
            </div>
        </div> )
        }
    </>
  );
}

export default ShowAlert;